import React from "react";

import { Property } from "manager/interfaces/api";
import { Modal } from "shared/components/Modal";
import useModal from "shared/hooks/useModal";

import { BILLING_STATUS, formatBillingDate } from "./billingDisplay";
import {
  PropertySummary,
  PropertySummaryName,
  PropertySummaryUnits,
  SetLiveBody,
} from "./styled";

interface CancelScheduledModalProps {
  property: Property;
  submit: () => Promise<void> | void;
  submitting?: boolean;
}

const CancelScheduledModal = ({
  property,
  submit,
  submitting = false,
}: CancelScheduledModalProps) => {
  const { closeActiveModalDialog } = useModal();
  const isStop = property.billingStatus === BILLING_STATUS.stopping;

  return (
    <Modal
      title="Cancel scheduled"
      subtitle={
        isStop ? "Stays live. Future stop is cleared." : "Stays in Onboarding."
      }
      submit={submit}
      submitButtonLabel="Confirm"
      submitting={submitting}
      closeOnSubmit={false}
      afterClose={closeActiveModalDialog}
      showCancelLink
      width={560}
    >
      <Modal.Body>
        <SetLiveBody>
          <PropertySummary>
            <PropertySummaryName>{property.name}</PropertySummaryName>
            <PropertySummaryUnits>
              {isStop
                ? `Stopping ${formatBillingDate(property.billingStoppedAt)}`
                : `Goes live ${formatBillingDate(property.billingLiveAt)}`}
            </PropertySummaryUnits>
          </PropertySummary>
        </SetLiveBody>
      </Modal.Body>
    </Modal>
  );
};

export default CancelScheduledModal;
